import React, { useEffect, useContext, useState } from 'react';
import { formatMoney } from "@shopify/theme-currency";
import { VariantOptionsForm } from './'

export const BundleCardSimple = ({ object }) => {
  const [selectedVariant, setSelectedVariant] = useState(object.variants.find(v => v.available) ? object.variants.find(v => v.available) : object.variants[0]);
  const [selectedOptions, setSelectedOptions] = useState(object.options.reduce((o, key) => ({ ...o, [key]: selectedVariant ? selectedVariant.options[object.options.indexOf(key)] : "" }), {}))

  useEffect(() => {
    setSelectedVariant(object.variants.find(v => Object.values(selectedOptions).every(r => v.options.includes(r))))
  }, [selectedOptions])

  const handleChange = e => {
    const newOptions = {
      ...selectedOptions,
      [e.target.name]: e.target.value
    }
    setSelectedOptions(newOptions)
  }

  return (
    <div className="Card Card--product" >
      <figure className='Card__figure'>
        {object.featured_image &&
          <img
            src={`${object.featured_image}&width=200`}
            srcSet={`${object.featured_image}&width=200 200w,${object.featured_image}&width=400 400w,${object.featured_image}&width=600 600w`}
            loading="lazy"
            alt={object.title}
          />
        }
      </figure>
      <div className='Card__details'>
        <h4 className='Card__title'>{object.title}</h4>
        {selectedVariant &&
          <div className='price'>{formatMoney(selectedVariant.price, theme.moneyFormat)}</div>
        }
        <VariantOptionsForm
          object={object}
          selectedVariant={selectedVariant}
          options={object.options}
          variants={object.variants}
          handleChange={handleChange}
        />
      </div>
    </div>
  )
}
